<template>
  <div class="todo-workbench-page">
    <div ref="filterBox" class="filter-box">
      <a-form layout="inline" class="demo-form-inline">
        <a-form-item>
          <a-input v-model="form.subject" placeholder="主题" allow-clear />
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.status" placeholder="状态" allow-clear>
            <a-select-option :value="0">未处理</a-select-option>
            <a-select-option :value="1">已取消</a-select-option>
            <a-select-option :value="2">已完成</a-select-option>
            <a-select-option :value="3">待确认</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-select v-model="form.is_overdue" placeholder="逾期" allow-clear>
            <a-select-option :value="true">已逾期</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-range-picker
            v-model="form.dateRange"
            show-time
            format="YYYY-MM-DD HH:mm:ss"
            value-format="YYYY-MM-DD HH:mm:ss"
            :placeholder="['开始时间', '结束时间']"
            separator="至"
          />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
          <a-button style="margin-left: 10px" @click="reset">重置</a-button>
        </a-form-item>
      </a-form>
    </div>
    <vxe-table :border="true" :data="dataSource" :height="tableHeight" resizable :loading="loading">
      <vxe-column field="id" title="ID" width="120" />
      <vxe-column field="code" title="编号" width="120" />
      <vxe-column field="subject" title="主题" min-width="200" show-overflow="tooltip" />
      <vxe-column field="category_name" title="分类" width="120" />
      <vxe-column field="status" title="状态" width="100">
        <template #default="{ row }">
          <a-tag v-if="row.status === 0" color="red">未处理</a-tag>
          <a-tag v-else-if="row.status === 1">已取消</a-tag>
          <a-tag v-else-if="row.status === 2" color="green">已完成</a-tag>
          <a-tag v-else-if="row.status === 3" color="orange">待确认</a-tag>
        </template>
      </vxe-column>
      <vxe-column field="expected_time" title="逾期时间" width="180" />
      <vxe-column field="create_time" title="创建时间" width="180" />
      <vxe-column field="ope" title="操作" width="120">
        <template #default="{ row }">
          <a-button size="small" @click="viewDetail(row)">查看详情</a-button>
        </template>
      </vxe-column>
    </vxe-table>
    <div class="pagination-wrapper">
      <a-pagination
        v-model="pagination.current"
        size="small"
        :total="pagination.total"
        :page-size="pagination.pageSize"
        :show-total="pagination.showTotal"
        @change="pageChange"
      />
    </div>
    <a-modal
      title="待办详情"
      :visible="detailDialogVisible"
      width="70%"
      :mask-closable="false"
      :footer="null"
      @cancel="detailDialogVisible = false"
      :after-close="onDetailClosed"
    >
      <a-spin :spinning="detailLoading" class="detail-content">
        <template v-if="currentRow.id && !detailLoading">
          <div class="detail-section">
            <div class="section-title">基本信息</div>
            <a-descriptions :column="2" bordered>
              <a-descriptions-item label="ID">{{ currentRow.id }}</a-descriptions-item>
              <a-descriptions-item label="编号">{{ currentRow.code }}</a-descriptions-item>
              <a-descriptions-item label="主题">{{ currentRow.subject }}</a-descriptions-item>
              <a-descriptions-item label="分类">{{ currentRow.category_path || currentRow.category_name }}</a-descriptions-item>
              <a-descriptions-item label="状态">
                <a-tag v-if="currentRow.status === 0" color="red">未处理</a-tag>
                <a-tag v-else-if="currentRow.status === 1">已取消</a-tag>
                <a-tag v-else-if="currentRow.status === 2" color="green">已完成</a-tag>
                <a-tag v-else-if="currentRow.status === 3" color="orange">待确认</a-tag>
              </a-descriptions-item>
              <a-descriptions-item label="是否逾期">
                <a-tag v-if="currentRow.is_overdue" color="red">已逾期</a-tag>
                <a-tag v-else color="green">未逾期</a-tag>
              </a-descriptions-item>
              <a-descriptions-item label="创建时间">{{ currentRow.create_time }}</a-descriptions-item>
              <a-descriptions-item label="更新时间">{{ currentRow.update_time }}</a-descriptions-item>
              <a-descriptions-item v-if="currentRow.complete_time" label="完成时间">{{ currentRow.complete_time }}</a-descriptions-item>
              <a-descriptions-item v-if="currentRow.cancel_time" label="取消时间">{{ currentRow.cancel_time }}</a-descriptions-item>
              <a-descriptions-item label="逾期时间">{{ currentRow.expected_time }}</a-descriptions-item>
              <a-descriptions-item label="逾期说明">{{ currentRow.human_timeout || '-' }}</a-descriptions-item>
            </a-descriptions>
          </div>

          <div v-if="currentRow.participant && currentRow.participant.length" class="detail-section">
            <div class="section-title">参与人</div>
            <a-descriptions :column="2" bordered>
              <a-descriptions-item v-for="p in currentRow.participant" :key="p.id" :label="'参与人'">
                {{ p.username }}
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div v-if="currentRow.content_list && currentRow.content_list.length" class="detail-section">
            <div class="section-title">内容列表</div>
            <div v-for="(content, idx) in currentRow.content_list" :key="content.id" class="content-card">
              <div class="content-card-header">
                <span class="content-index">内容 #{{ idx + 1 }}</span>
                <a-tag v-if="content.handle_status === 0" color="red">未处理</a-tag>
                <a-tag v-else-if="content.handle_status === 2" color="green">已完成</a-tag>
              </div>
              <a-descriptions :column="2" bordered size="small">
                <a-descriptions-item label="唯一标识">{{ content.uni_code }}</a-descriptions-item>
                <a-descriptions-item label="SKU">
                  <div class="sku-list">
                    <a-tag v-for="sku in parseSku(content.sku)" :key="sku" class="sku-tag">{{ sku }}</a-tag>
                  </div>
                </a-descriptions-item>
                <a-descriptions-item label="平台ID">{{ content.platform_id }}</a-descriptions-item>
                <a-descriptions-item label="内容类型">{{ content.content_type || '-' }}</a-descriptions-item>
                <a-descriptions-item label="处理链接" :span="2">
                  <a v-if="content.handle_link" :href="content.handle_link" target="_blank" class="link">{{ content.handle_link }}</a>
                  <span v-else>-</span>
                </a-descriptions-item>
              </a-descriptions>
              <div v-if="content.exinfos" class="exinfos-box">
                <div class="exinfos-title">扩展信息</div>
                <div v-if="content.exinfos.project_info" class="exinfos-item">
                  <span class="exinfos-label">项目信息:</span>
                  <span v-if="content.exinfos.project_info.name">
                    {{ content.exinfos.project_info.name }}
                    <a-tag v-if="content.exinfos.project_info.level" color="orange">{{ content.exinfos.project_info.level }}</a-tag>
                  </span>
                  <span v-else>-</span>
                </div>
                <div v-if="content.exinfos.shipment_status !== undefined && content.exinfos.shipment_status !== null" class="exinfos-item">
                  <span class="exinfos-label">发货状态:</span>
                  <a-tag v-if="content.exinfos.shipment_status === 0">未发货</a-tag>
                  <a-tag v-else-if="content.exinfos.shipment_status === 1" color="green">已发货</a-tag>
                  <a-tag v-else>{{ content.exinfos.shipment_status }}</a-tag>
                </div>
                <div v-if="content.exinfos.sku && content.exinfos.sku.length" class="exinfos-item">
                  <span class="exinfos-label">SKU 列表:</span>
                  <div class="sku-list">
                    <a-tag v-for="sku in content.exinfos.sku" :key="sku" class="sku-tag">{{ sku }}</a-tag>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div v-if="currentRow.record_list && currentRow.record_list.length" class="detail-section">
            <div class="section-title">操作记录</div>
            <a-timeline>
              <a-timeline-item v-for="record in currentRow.record_list" :key="record.id" :color="record.record_type === 2 ? 'green' : 'blue'">
                <div class="record-card">
                  <div class="record-type">
                    <a-tag v-if="record.record_type === 1" color="blue">评论</a-tag>
                    <a-tag v-else-if="record.record_type === 2" color="green">状态变更</a-tag>
                  </div>
                  <div class="record-comment">{{ record.comment }}</div>
                  <div v-if="record.old_status !== undefined && record.new_status !== undefined" class="record-status-change">
                    <span>状态: </span>
                    <a-tag v-if="record.old_status === 0" color="red">未处理</a-tag>
                    <a-tag v-else-if="record.old_status === 1">已取消</a-tag>
                    <a-tag v-else-if="record.old_status === 2" color="green">已完成</a-tag>
                    <a-tag v-else>{{ record.old_status }}</a-tag>
                    <span style="margin: 0 8px">→</span>
                    <a-tag v-if="record.new_status === 0" color="red">未处理</a-tag>
                    <a-tag v-else-if="record.new_status === 1">已取消</a-tag>
                    <a-tag v-else-if="record.new_status === 2" color="green">已完成</a-tag>
                    <a-tag v-else>{{ record.new_status }}</a-tag>
                  </div>
                  <div class="record-user">操作人: {{ record.update_user }}</div>
                </div>
                <div class="record-time">{{ record.create_time }}</div>
              </a-timeline-item>
            </a-timeline>
          </div>

          <div v-if="currentRow.attachment_list && currentRow.attachment_list.length" class="detail-section">
            <div class="section-title">附件</div>
            <a-descriptions :column="1" bordered>
              <a-descriptions-item v-for="(att, idx) in currentRow.attachment_list" :key="idx" :label="'附件 ' + (idx + 1)">
                <a :href="att.url" target="_blank">{{ att.name || att.url }}</a>
              </a-descriptions-item>
            </a-descriptions>
          </div>

          <div v-if="currentRow.status === 0" class="dialog-actions">
            <a-button type="primary" @click="showConfirm(3, '标记完成')">标记完成</a-button>
            <a-button style="margin-left: 10px" @click="showConfirm(1, '标记取消')">标记取消</a-button>
            <a-button style="margin-left: 10px" @click="detailDialogVisible = false">关闭</a-button>
          </div>
          <div v-else class="dialog-actions">
            <a-button @click="detailDialogVisible = false">关闭</a-button>
          </div>
        </template>
      </a-spin>
    </a-modal>

    <a-modal v-model="confirmVisible" :title="confirmAction.label" :zIndex="3000" @ok="onConfirmSubmit" :confirm-loading="confirmSubmitting">
      <p>确认{{ currentRow.id ? '对待办 #' + currentRow.id + ' 执行' : '' }}「{{ confirmAction.label }}」操作？</p>
      <a-form layout="vertical">
        <a-form-item :label="confirmAction.status === 1 ? '取消备注（必填）' : '备注'">
          <a-textarea v-model="confirmComment" :placeholder="confirmAction.status === 1 ? '请输入取消原因' : '输入操作备注（可选）'" :rows="3" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { getUserTodoList, getUserTodoDetail, handleUserTodo } from '@/api/user-todo'

export default {
  data() {
    return {
      dataSource: [],
      tableHeight: null,
      loading: false,
      detailDialogVisible: false,
      detailLoading: false,
      currentRow: {},
      confirmVisible: false,
      confirmSubmitting: false,
      confirmAction: { status: 0, label: '' },
      confirmComment: '',
      pagination: {
        current: 1,
        pageSize: 20,
        total: 0,
        showTotal: total => `共 ${total} 条`
      },
      form: {
        subject: '',
        status: undefined,
        is_overdue: undefined,
        dateRange: null
      }
    }
  },
  created() {
    this.fetchData()
  },
  mounted() {
    this.calcTableHeight()
    window.addEventListener('resize', this.calcTableHeight)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.calcTableHeight)
  },
  methods: {
    fetchData(params = {}) {
      this.loading = true
      const query = {
        page_num: this.pagination.current,
        page_size: this.pagination.pageSize,
        ...this.buildQuery(),
        ...params
      }
      getUserTodoList(query)
        .then(res => {
          this.loading = false
          if (res.code === 0) {
            this.dataSource = res.data.list
            this.pagination.total = res.data.total
          }
        })
        .catch(() => {
          this.loading = false
        })
    },
    buildQuery() {
      const query = {}
      if (this.form.subject) {
        query.subject = this.form.subject
      }
      if (this.form.status !== null && this.form.status !== undefined) {
        query.status = this.form.status
      }
      if (this.form.is_overdue) {
        query.is_overdue = true
      }
      if (this.form.dateRange && this.form.dateRange.length === 2) {
        query.create_time = this.form.dateRange
      }
      return query
    },
    search() {
      this.pagination.current = 1
      this.fetchData()
    },
    reset() {
      this.form = {
        subject: '',
        status: undefined,
        is_overdue: undefined,
        dateRange: null
      }
      this.pagination.current = 1
      this.fetchData()
    },
    pageChange(e) {
      this.pagination.current = e
      this.fetchData()
    },
    viewDetail(row) {
      this.currentRow = { id: row.id }
      this.detailDialogVisible = true
      this.detailLoading = true
      getUserTodoDetail(row.id)
        .then(res => {
          if (res.code === 0) {
            this.currentRow = res.data
          }
          this.detailLoading = false
        })
        .catch(() => {
          this.detailLoading = false
        })
    },
    onDetailClosed() {
      this.currentRow = {}
      this.confirmComment = ''
    },
    showConfirm(status, label) {
      this.confirmAction = { status, label }
      this.confirmComment = ''
      this.confirmVisible = true
    },
    onConfirmSubmit() {
      if (this.confirmAction.status === 1 && !this.confirmComment.trim()) {
        this.$message.warning('标记取消时请填写取消原因')
        return
      }
      this.confirmSubmitting = true
      handleUserTodo({
        id: [this.currentRow.id],
        status: this.confirmAction.status,
        comment: this.confirmAction.status === 1 ? this.confirmComment || undefined : undefined
      })
        .then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功')
            this.confirmVisible = false
            this.confirmComment = ''
            this.detailDialogVisible = false
            this.fetchData()
          }
          this.confirmSubmitting = false
        })
        .catch(() => {
          this.confirmSubmitting = false
        })
    },
    parseSku(skuStr) {
      if (!skuStr) return []
      try {
        const parsed = JSON.parse(skuStr)
        if (Array.isArray(parsed)) return parsed
        return [skuStr]
      } catch (e) {
        return [skuStr]
      }
    },
    calcTableHeight() {
      const pageHeight = window.innerHeight
      const headerHeight = 64
      const contentMargin = 48
      const contentPadding = 48
      const filterHeight = this.$refs.filterBox ? this.$refs.filterBox.offsetHeight : 52
      const paginationHeight = 52
      const extraGap = 0
      this.tableHeight = pageHeight - headerHeight - contentMargin - contentPadding - filterHeight - paginationHeight - extraGap
    }
  }
}
</script>

<style scoped>
.todo-workbench-page {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.filter-box {
  margin-bottom: 10px;
  flex-shrink: 0;
}

.pagination-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
  flex-shrink: 0;
}

.detail-content {
  min-height: 200px;
}

.detail-section {
  margin-bottom: 24px;
}

.section-title {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 12px;
  padding-left: 8px;
  border-left: 4px solid #409eff;
  color: #303133;
}

.content-card {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 16px;
  background: #fafafa;
}

.content-card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
  padding-bottom: 8px;
  border-bottom: 1px solid #ebeef5;
}

.content-index {
  font-weight: bold;
  color: #303133;
}

.sku-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.sku-tag {
  margin: 0;
}

.exinfos-box {
  margin-top: 12px;
  padding: 12px;
  background: #f5f7fa;
  border-radius: 4px;
}

.exinfos-title {
  font-weight: bold;
  margin-bottom: 8px;
  color: #606266;
}

.exinfos-item {
  margin-bottom: 6px;
  display: flex;
  align-items: flex-start;
}

.exinfos-label {
  color: #909399;
  margin-right: 8px;
  min-width: 70px;
  flex-shrink: 0;
}

.record-card {
  background: #f5f7fa;
  padding: 12px;
  border-radius: 4px;
}

.record-type {
  margin-bottom: 6px;
}

.record-comment {
  color: #303133;
  margin-bottom: 6px;
  font-size: 14px;
}

.record-status-change {
  margin-bottom: 6px;
  font-size: 13px;
}

.record-user {
  color: #909399;
  font-size: 12px;
}

.record-time {
  margin-top: 4px;
  color: #909399;
  font-size: 12px;
}

.link {
  color: #409eff;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}

.dialog-actions {
  margin-top: 24px;
  text-align: center;
  padding-top: 16px;
  border-top: 1px solid #ebeef5;
}
</style>
